import { render, staticRenderFns } from "./getCompliancerule.vue?vue&type=template&id=0f6e43e3"
import script from "./getCompliancerule.vue?vue&type=script&lang=js"
export * from "./getCompliancerule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports